import { CommitmentType, Dates, ProviderType } from "@/services/cloudchipr.api";
import { objectToUrl } from "@/components/utils/helpers/dataToUrlToDataConvertors";

export const getCommitmentsResourceUrl = (
  provider: ProviderType,
  orgId: string,
  coverageUrlActiveTab: CommitmentType,
  viewTab: "commitment" | "coverage",
  searchValue: string,
  dates: Dates,
): string => {
  const filteredDates = Object.fromEntries(
    Object.entries(dates).filter(
      ([_, value]) => value !== undefined && value !== null,
    ),
  );
  const datesPath = objectToUrl(filteredDates);

  return `/commitments/${provider}/${orgId}?active=${coverageUrlActiveTab}&view_tab=${viewTab}&search=${searchValue}&dates=${datesPath}`;
};
